import React, { useEffect } from "react";
import dataImage from "../Media/service6_data_banner.jpg";
import analysisImage from "../Media/service6_data_analysis.avif";
import visualizationImage from "../Media/service6_data_visualization.avif";
import machineLearningImage from "../Media/service6_data_ml.jpg";
import Banner from '../Components/Banner.tsx';
import { useNavigate } from "react-router-dom";
import ProgressiveImageCustom from "../Components/ProgressiveImageCustom.tsx";

export default function DataScience() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target); // Stops observing after first appearance
          }
        });
      },
      { threshold: 0.2 }
    );
    

    const items = document.querySelectorAll(".services-list li");
    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  const handleInquiry = (featureName) => {
    navigate("/inquiry", { state: { preselectedTopic: featureName } });
  };

  return (
    <div className="service">
      <div className="page-content">
        <Banner
          image={dataImage}
          textTop="Data Science Lösungen"
          textBottom="Nutzen Sie das Potenzial Ihrer Daten für fundierte Entscheidungen."
          textColor="#ffffff"
        />

<section className="textcontainer">
  <div className="spacer-div-30px"></div>
  <h1>Individuelle Data&shy;-Science&shy;-Lösungen für Ihr Unternehmen</h1>
  <p>
    In der heutigen digitalen Welt sind Daten der Schlüssel zu fundierten Entscheidungen und nachhaltigem Unternehmenserfolg. 
    Doch Rohdaten allein bieten wenig Mehrwert – erst durch eine gezielte Analyse, professionelle Visualisierung und 
    den Einsatz intelligenter Modelle entstehen wertvolle Erkenntnisse. Wir unterstützen Ihr Unternehmen dabei, das volle Potenzial 
    Ihrer Daten auszuschöpfen, um Prozesse zu optimieren, Wettbewerbsvorteile zu sichern und innovative Geschäftsmodelle zu entwickeln.
  </p>
  <hr></hr>

  <ul className="services-list">
    <li>
      <div className="list-title">
        <strong>Daten&shy;analyse & Erkenntnis&shy;gewinn – Verstehen Sie Ihre Daten auf einer tieferen Ebene</strong>
      </div>
      <ProgressiveImageCustom src={analysisImage} />
      <div className="list-description">
        <p>
          Die systematische Analyse grosser Datenmengen liefert essenzielle Erkenntnisse über Ihre Geschäfts&shy;prozesse, 
          Kundenverhalten und Markttrends. Mit fortschrittlichen statistischen Methoden, explorativer Datenanalyse (EDA) 
          und modernen Predictive&shy;-Analytics&shy;-Technologien helfen wir Ihnen, verborgene Muster zu entdecken und 
          datenbasierte Entscheidungen zu treffen. Unsere Lösungen umfassen:
        </p>
        <ul>
          <li><strong>Explorative Daten&shy;analyse:</strong> <br></br> Identifikation von Trends und Auffälligkeiten, die wertvolle Geschäftseinblicke liefern.</li>
          <li><strong>Statistische Modellierung:</strong> <br></br> Quantifizierung von Zusammenhängen, um genaue Analysen und fundierte Entscheidungen zu ermöglichen.</li>
          <li><strong>Prädiktive Analysen:</strong> <br></br> Nutzen Sie unsere fortschrittlichen Modelle zur Vorhersage von zukünftigen Trends und Ereignissen.</li>
          <li><strong>Datenbasierte Entscheidungs&shy;modelle:</strong> <br></br> Entwickeln Sie Strategien und Lösungen, die auf verlässlichen Daten und präzisen Modellen basieren.</li>
        </ul>
      </div>
    </li>

    <li>
      <div className="list-title">
        <strong>Daten&shy;visualisierung & Dashboards – Interaktive Insights für fundierte Entscheidungen</strong>
      </div>
      <ProgressiveImageCustom src={visualizationImage} />
      <div className="list-description">
        <p>
          In einer datengetriebenen Welt ist eine effektive Visualisierung entscheidend, um komplexe Zusammenhänge 
          verständlich darzustellen. Wir entwickeln massgeschneiderte interaktive Dashboards, die es Ihnen ermöglichen, 
          Ihre KPIs in Echtzeit zu überwachen, Geschäftsprozesse zu steuern und strategische Entscheidungen zu optimieren. 
          Unsere Lösungen bieten:
        </p>
        <ul>
          <li><strong>Benutzer&shy;freundliche Dashboards:</strong> <br></br> Mit anpassbaren Filter&shy;optionen, die Ihnen die vollständige Kontrolle über Ihre Daten bieten.</li>
          <li><strong>Echtzeit-Daten&shy;visualisierungen:</strong> <br></br> Visualisieren Sie Daten in Echtzeit, um sofortige Einblicke und schnelle Entscheidungen zu ermöglichen.</li>
          <li><strong>Integration mit gängigen BI-Tools:</strong> <br></br> (Tableau, Power BI, D3.js, Plotly) für flexible und effiziente Datenanalyse.</li>
          <li><strong>Automatisierte Bericht&shy;erstellung:</strong> <br></br> Optimieren Sie Ihre Arbeitsabläufe mit automatisierten Berichten, die Ihnen die richtigen Informationen zur richtigen Zeit liefern.</li>
        </ul>
      </div>
    </li>

    <li>
      <div className="list-title">
        <strong>Machine&shy; Learning & Künstliche&shy; Intelligenz – Smarte Algorithmen für automatisierte Prozesse</strong>
      </div>
      <ProgressiveImageCustom src={machineLearningImage} />
      <div className="list-description">
        <p>
          Machine&shy;-Learning und Künstliche&shy;-Intelligenz revolutionieren die Art und Weise, wie Unternehmen 
          Daten nutzen. Wir entwickeln maßgeschneiderte KI-basierte Lösungen, die Ihre Geschäftsprozesse automatisieren, 
          Effizienz steigern und neue Geschäftsmöglichkeiten eröffnen. Unsere Expertise umfasst:
        </p>
        <ul>
          <li><strong>Entwicklung und Implementierung von Machine&shy;-Learning-Modellen:</strong> <br></br> Wir passen Modelle an, die speziell auf Ihre Unternehmensbedürfnisse zugeschnitten sind.</li>
          <li><strong>Neuronale Netze:</strong> <br></br> Setzen Sie komplexe neuronale Netze ein, um tiefere und genauere Datenanalysen durchzuführen.</li>
          <li><strong>Klassifikations- und Clustering-Methoden:</strong> <br></br> Wir helfen Ihnen dabei, Muster und Gruppen aus großen Datenmengen zu extrahieren.</li>
          <li><strong>Prognosemodelle:</strong> <br></br> Optimieren Sie Ihre Geschäftsstrategien mit präzisen Vorhersagemodellen, die zukünftige Entwicklungen vorhersehen.</li>
        </ul>
      </div>
    </li>
  </ul>
</section>


        <button
                 className="anfrage-btn not-on-grid"
          onClick={() => handleInquiry("Datenanalyse")}
        >
          Anfragen
        </button>
      </div>
    </div>
  );
}
